// extracted by mini-css-extract-plugin
export default {"Tooltip":"Tooltip_Tooltip__kkcnR","buttons":"Tooltip_buttons__cNVfA","body":"Tooltip_body__WeAvA","name":"Tooltip_name__bzdpt"};